import script from "./Ad.vue?vue&type=script&setup=true&lang=js"
export * from "./Ad.vue?vue&type=script&setup=true&lang=js"

import "./Ad.vue?vue&type=style&index=0&id=09b8c016&lang=css"

const __exports__ = script;

export default __exports__